import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

import {
  PiModalMensajeGenericoService
} from './pi-modal-mensaje-generico.service';

@Component({
  selector: 'app-modal-host',
  standalone: true,
  template: '<ng-container #modalOutlet></ng-container>'
})
export class ModalHostComponent implements OnInit, OnDestroy {

  @ViewChild('modalOutlet', {
    read: ViewContainerRef,
    static: true
  })
  private readonly modalOutlet!: ViewContainerRef;

  constructor(
    private readonly modalService: PiModalMensajeGenericoService
  ) {}

  ngOnInit(): void {
    this.modalService.registerOutlet(this.modalOutlet);
  }

  ngOnDestroy(): void {
    this.modalService.unregisterOutlet(this.modalOutlet);
  }
}